import { html } from "lit";
var icon_assets_default = () => html`
  <svg viewBox="0 0 26 27" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.72 3.02c1.27 0 2.3.98 2.38 2.21V6h9.69c1.26 0 2.3.98 2.38 2.22V10.48h.63c.69 0 1.33.29 1.78.79l.11.13c.42.54.58 1.22.46 1.87l-.04.16-2.22 8.96a2.38 2.38 0 0 1-2.15 1.75H3.4a.89.89 0 0 1-.2-.02l-.04-.01-.09-.01a2.57 2.57 0 0 1-2.24-2.36V5.38c0-1.26.98-2.28 2.23-2.36h4.67zm15.08 9.19H8.85a.64.64 0 0 0-.57.34l-.02.07-2.38 9.64-.02.07-.03.08H20.6c.26 0 .48-.15.58-.36l.03-.08L23.4 13a.62.62 0 0 0-.1-.54.63.63 0 0 0-.41-.24l-.1-.01zM7.72 4.75H3.2a.63.63 0 0 0-.63.54v16.29c0 .4.3.75.72.8a.84.84 0 0 0 .87-.47l.03-.1 2.38-9.63a2.38 2.38 0 0 1 2.13-1.7h11.72V8.36a.63.63 0 0 0-.55-.62H9.23a.87.87 0 0 1-.87-.77v-1.6a.63.63 0 0 0-.55-.61l-.09-.01z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_assets_default as default
};
//# sourceMappingURL=icon-assets.js.map
